/**
 * Faixa de benefícios: no celular vira carrossel que passa sozinho.
 * Pausa enquanto a pessoa arrasta e respeita "reduzir movimento".
 */
class BeneficiosFaixa extends HTMLElement {
  connectedCallback() {
    this.trilho = this.querySelector('[data-trilho]');
    this.pontos = this.querySelector('[data-pontos]');
    this.itens = [...this.trilho.children];
    this.intervalo = Number(this.dataset.intervalo) || 3000;
    this.mobile = window.matchMedia('(max-width: 749px)');

    this.pontos.innerHTML = this.itens.map(() => '<span></span>').join('');
    this.trilho.addEventListener('scroll', this.#marcarPonto, { passive: true });
    this.trilho.addEventListener('pointerdown', this.#pausar);
    this.trilho.addEventListener('touchstart', this.#pausar, { passive: true });
    this.mobile.addEventListener('change', this.#iniciar);
    this.#marcarPonto();
    this.#iniciar();
  }

  disconnectedCallback() {
    this.#parar();
    this.mobile?.removeEventListener('change', this.#iniciar);
  }

  #indiceAtual() {
    return Math.round(this.trilho.scrollLeft / Math.max(this.trilho.clientWidth, 1));
  }

  #marcarPonto = () => {
    const atual = this.#indiceAtual();
    [...this.pontos.children].forEach((p, i) => p.classList.toggle('ativo', i === atual));
  };

  #iniciar = () => {
    this.#parar();
    const reduzir = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!this.mobile.matches || reduzir || this.itens.length < 2) return;
    this.timer = setInterval(() => {
      const proximo = (this.#indiceAtual() + 1) % this.itens.length;
      this.trilho.scrollTo({ left: proximo * this.trilho.clientWidth, behavior: 'smooth' });
    }, this.intervalo);
  };

  #parar = () => {
    clearInterval(this.timer);
    clearTimeout(this.retomar);
  };

  /** A pessoa arrastou: pausa e volta a girar sozinho depois de um tempo. */
  #pausar = () => {
    this.#parar();
    this.retomar = setTimeout(this.#iniciar, this.intervalo * 2);
  };
}

if (!customElements.get('beneficios-faixa')) customElements.define('beneficios-faixa', BeneficiosFaixa);
